import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess201004Status: 'idle',
    startProcess201004Error: undefined as any,
    loadUserParamsProcess201004Status: 'idle',
    loadUserParamsProcess201004Error: undefined as any,

    process201004List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess201004 = createAsyncThunk('process201004Slice/startProcess201004', async ({ process201004 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess201004/`,
        prepareData(process201004),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess201004Status } = getState().process201004Slice
        return startProcess201004Status !== 'pending'
    }
})

export const loadUserParamsProcess201004 = createAsyncThunk('process201004Slice/loadUserParamsProcess201004', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess201004/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess201004Status } = getState().process201004Slice
        return loadUserParamsProcess201004Status !== 'pending'
    }
})

const Process201004Slice = createSlice({
    name: 'process201004Slice',
    initialState,
    reducers: {
        resetstartProcess201004: (state) => {
            state.job = undefined
            state.startProcess201004Error = undefined
        },
        resetstartProcess201004Error: (state) => {
            state.startProcess201004Error = undefined
        },
        resetloadUserParamsProcess201004: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess201004Error = undefined
        },
        resetloadUserParamsProcess201004Error: (state) => {
            state.loadUserParamsProcess201004Error = undefined
        },
        removeFromProcess201004ListById: (state, action) => {
            state.process201004List = state.process201004List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess201004ListByIds: (state, action) => {
            state.process201004List = state.process201004List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process201004List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess201004Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process201004List = []
            state.startProcess201004Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess201004.pending, (state) => {
            state.startProcess201004Status = 'pending'
            state.startProcess201004Error = undefined
        })
        builder.addCase(startProcess201004.fulfilled, (state, action) => {
            state.startProcess201004Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess201004.rejected, (state, action) => {
            state.startProcess201004Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess201004Error = action.error.message
            } else {
                state.startProcess201004Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess201004.pending, (state) => {
            state.loadUserParamsProcess201004Status = 'pending'
            state.loadUserParamsProcess201004Error = undefined
        })
        builder.addCase(loadUserParamsProcess201004.fulfilled, (state, action) => {
            state.loadUserParamsProcess201004Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess201004.rejected, (state, action) => {
            state.loadUserParamsProcess201004Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess201004Error = action.error.message
            } else {
                state.loadUserParamsProcess201004Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess201004,
    resetstartProcess201004Error,
    resetloadUserParamsProcess201004,
    resetloadUserParamsProcess201004Error,
    removeFromProcess201004ListById,
    removeFromProcess201004ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process201004Slice.actions
export default Process201004Slice.reducer
